import React from "react";
import "./heading.scss";

export const Heading: React.FC<{}> = () => (
  <h1 className="c-heading">
    <a href="/#/">Process Refunds</a>
  </h1>
);
